import { gql } from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';

export const GET_CLASSROOM_TIMETABLE = gql`
  query GetClassroomTimetable($id: ID!) {
    timetable(id: $id) {
      id
      title
      template {
        id
        name
        timeSlots {
          id
          name
          start_time
          end_time
          type
          color
        }
      }
      entries {
        id
        day_of_week
        teachable {
          __typename
          ... on Subject { id name }
          ... on Course { id course_code course_title }
        }
        staff {
          id
          user {
            id
            name
          }
        }
        timeSlot {
          id
          name
          start_time
          end_time
        }
        room_name
        custom_title
      }
    }
  }
`;
// ... existing code ...
export const GET_ALL_STAFF = gql`
  query GetAllStaff {
    getStaff(first: 1000) {
      data {
        id
        user {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_SUBJECTS = gql`
  query GetAllSubjects {
    listSchoolSubjects {
        id
        name
    }
  }
`;

export const GET_ALL_COURSES = gql`
  query GetAllCourses($first: Int = 100, $page: Int = 1) {
    listSchoolCourses(first: $first, page: $page) {
      data {
        id
        course_code
        course_title
      }
    }
  }
`;

export const GET_TIMETABLE_TEMPLATES = gql`
  query GetTimetableTemplates {
    timetableTemplates {
      id
      name
      timeSlots {
        id
        name
        start_time
        end_time
        type
        color
      }
    }
  }
`;

export const GET_TIMETABLES = gql`
  query GetTimetables($first: Int, $page: Int, $timeable_id: ID, $timeable_type: TimetableTimeableType) {
    timetables(first: $first, page: $page, timeable_id: $timeable_id, timeable_type: $timeable_type) {
      data {
        id
        title
        template {
          id
          name
          timeSlots {
            id
            name
            start_time
            end_time
            type
            color
          }
        }
        entries {
          id
          day_of_week
          teachable {
            __typename
            ... on Subject { id name }
            ... on Course { id course_code course_title }
          }
          staff {
            id
            user {
               id
               name
             }
          }
          timeSlot {
             id
             name
             start_time
             end_time
           }
          room_name
          custom_title
        }
        timeable {
          ... on Classroom {
            id
            classroomName: name
          }
          ... on ClassroomSection {
            id
            sectionName: name
            classroom {
              id
              name
            }
            section {
              id
              name
            }
          }
        }
      }
    }
  }
`;
